import _ from 'lodash';
import ConstantsStorage from '../../constants';
import PaymentApi from '../../api/payment';
import {NotificationError, NotificationInfo, NotificationSuccess} from '../../services/notifications';
import {ActionModalHide,} from './actions-modal';
import {ActionRouteNavigate} from './actions-route';
import {ROUTES} from '../../configs/routes';
import {t} from '../../services/i18nHandler';

const Constants = ConstantsStorage();

export function ActionStoreCartData(key, data, remember) {
  return {
    type: Constants.CART_ACTIONS.UPDATE,
    key,
    data,
    remember,
  };
}

export function ActionClearStoreCartData() {
  return {
    type: Constants.CART_ACTIONS.CLEAR,
  };
}

export function ActionAddToCart(tariffId, tariffPeriod, tariffName, tariffType) {
  return (dispatch, getState) => {
    const state = getState();
    const user = state.rUser;
    const userId = user._id;
    const cartData = state.rCart.cartData || {};
    const userCartData = cartData[userId] || [];
    const hasInCart = _.find(userCartData, {tariffId});
    if (!hasInCart) {
      const newCartData = {...cartData};
      let newUserCartData = [...userCartData];
      if (tariffType === 1) {
        newUserCartData = userCartData.filter((item) => (item.type !== 1));
      }
      newUserCartData.push({
        tariffId,
        tariffPeriod,
        name: tariffName,
        type: tariffType,
      });
      newCartData[userId] = newUserCartData;
      NotificationInfo(t('tariffs.addToCart'));
      dispatch(ActionStoreCartData('cartData', newCartData));
    }
  };
}

export function ActionSetNewCartItemPeriod(tariffId, tariffPeriod) {
  return (dispatch, getState) => {
    const state = getState();
    const user = state.rUser;
    const userId = user._id;
    const cartData = state.rCart.cartData || {};
    const userCartData = cartData[userId] || [];
    const newCartData = {...cartData};
    newCartData[userId] = userCartData.map((item) => {
      if (item.tariffId === tariffId) {
        return {...item, tariffPeriod};
      }
      return item;
    });
    dispatch(ActionStoreCartData('cartData', newCartData));
  };
}

export function ActionRemoveFromCart(tariffId) {
  return (dispatch, getState) => {
    const state = getState();
    const user = state.rUser;
    const userId = user._id;
    const cartData = state.rCart.cartData || {};
    const userCartData = cartData[userId] || [];
    const newCartData = {...cartData};
    newCartData[userId] = userCartData.filter((item) => (item.tariffId !== tariffId));
    dispatch(ActionStoreCartData('cartData', newCartData));
  };
}

export function ActionRequestSetCheck(paymentData, isFormData) {
  return (dispatch) => PaymentApi.requestSetCheck(paymentData, isFormData).then(() => {
    NotificationSuccess('Счет на оплату успешно отправлен');
    dispatch(ActionRouteNavigate({
      pathname: ROUTES.PROFILE_SETTINGS.route,
      hash: '#company',
    }));
  }).catch((error) => {
    dispatch(ActionModalHide());
    if (error.error.statusCode < 200 || error.error.statusCode > 300) {
      NotificationError(
        `Failed pay using CloudPayments. reason: ${error.error.statusCode} - ${error.error.statusText}`,
      );
    }
  }).finally(() => {});
}
